import React, { useEffect, useRef } from 'react'
import { LoadingOverlay } from '../loading';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from './useAuth';

const RegistrationForm = ({ setScreen, first_name, setFirst_Name, last_name, setLast_Name, day, setDay, month, setMonth, year, setYear, date, setDate, email, setEmail, password, setPassword, handleRegistration, errorMessage }) => {
    const location = useLocation()
    
    const submitRegistration = () => {
        const emailInput = document.getElementById('email');
        if (emailInput.validity.valid) {
            handleRegistration()
        } else {
            emailInput.reportValidity()
        }
    }
    
    function handleChange(setValue, e, i) {
        const { maxLength, value, name } = e.target
        setValue(value)
        if (value.length === maxLength) {
            if (i !== 3) {
                document.getElementById(`field-${i+1}`).focus()
            }
        }
        if (document.getElementById('field-1').value.length === 2) {
            if (document.getElementById('field-2').value.length === 2) {
                if (document.getElementById('field-3').value.length === 4) {
                    setDate({
                        'day': document.getElementById('field-1').value,
                        'month': document.getElementById('field-2').value,
                        'year': document.getElementById('field-3').value
                    })
                } else {
                    setDate()
                }
            } else {
                setDate()
            }
        } else {
            setDate()
        }
    }

    return (
        <div className="w-full">
            <div className="space-y-4 md:space-y-6">
                <h1 className={"leading-tight tracking-tight text-gray-900 " + (location.pathname === '/s%C3%A6lgbog' ? "text-base xl:text-lg font-medium" : "text-xl md:text-2xl font-bold")}>
                    Opret konto
                </h1>
                {(errorMessage !== '') ?
                    <div className="text-center text-sm w-full py-4 px-2 bg-red-200">
                        <p>{errorMessage}</p>
                    </div>
                :
                    ""
                }
                <div className="space-y-4 md:space-y-6">
                    <div className="block sm:flex gap-x-4 space-y-4 sm:space-y-0">
                        <div className="w-full">
                            <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900">Fornavn</label>
                            <input autoFocus type="first_name" name="first_name" id="first_name" autoComplete='off' onKeyDown={(e) => e.key === 'Enter' && document.getElementById('last_name').focus()} className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={first_name} onChange={(e) => setFirst_Name(e.target.value)} required />
                        </div>
                        <div className="w-full">
                            <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900">Efternavn</label>
                            <input type="last_name" name="last_name" id="last_name" autoComplete='off' onKeyDown={(e) => e.key === 'Enter' && document.getElementById('field-1').focus()} className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={last_name} onChange={(e) => setLast_Name(e.target.value)} required />
                        </div>
                    </div>
                    <div>
                        <label for="dob" className="block mb-2 text-sm font-medium text-gray-900">Fødselsdagsdato</label>
                        <div className="flex gap-2 items-center relative">
                            <input type="text" autoComplete='off' inputmode="numeric" id="field-1" onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "")} maxLength="2" placeholder="DD" className="bg-transparent text-center flex-[1] w-full border-b border-gray-300 block focus:outline-none p-4 text-sm text-gray-900" onChange={(e) => handleChange(setDay, e, 1)} />
                            <input type="text" autoComplete='off' inputmode="numeric" id="field-2" onKeyUp={(e) => (e.key === 'Backspace') ? (e.target.value.length === 0) ? document.getElementById('field-1').focus() : "" : ""} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "")} maxLength="2" placeholder="MM" className="bg-transparent text-center flex-[1] w-full border-b border-gray-300 block focus:outline-none p-4 text-sm text-gray-900" onChange={(e) => handleChange(setMonth, e, 2)} />
                            <input type="text" autoComplete='off' inputmode="numeric" id="field-3" onKeyDown={(e) => e.key === 'Enter' && document.getElementById('field-3').value.length === 4 && document.getElementById('password').focus()} onKeyUp={(e) => (e.key === 'Backspace') ? (e.target.value.length === 0) ? document.getElementById('field-2').focus() : "" : ""} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "")} maxLength="4" placeholder="YYYY" className="bg-transparent text-center flex-[2] w-full border-b border-gray-300 block focus:outline-none p-4 text-sm text-gray-900" onChange={(e) => handleChange(setYear, e, 3)} />
                        </div>
                    </div>
                    <div>
                        <label for="email" className="block mb-2 text-sm font-medium text-gray-900">Email</label>
                        <input type="email" name="email" id="email" autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={email} onChange={(e) => setEmail(e.target.value) & e.target.setCustomValidity("")} required />
                    </div>
                    <div>
                        <label for="password" className="block mb-2 text-sm font-medium text-gray-900">Adgangskode</label>
                        <input type="password" name="password" id="password" autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === 'Enter' ? submitRegistration() : ""} required />
                    </div>
                    <button type="submit" onClick={submitRegistration} className="focus:bg-pos-100 w-full text-white bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 transition-all duration-150 ease-in-out outline-none font-medium text-sm px-5 py-2.5 text-center">Opret konto</button>
                    <p className="text-sm">
                        Har du allerede en konto? <span className="font-medium hover:text-black transition-all duration-100 text-nowrap cursor-pointer" onClick={() => setScreen(1)}>Log ind</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default RegistrationForm